import React from 'react';
import { Descriptions } from 'antd';

const labelWithFormat = (label, translation) => (
  <span>
    <strong>{label}</strong>{' '}
    <span style={{ color: '#fa541c' }}>({translation})</span>
  </span>
);

const GLNDetails = ({ data }) => {
  const gln = data?.localizacion?.[0];
  const cliente = gln?.cliente;
  const ciudad = gln?.ciudad;
  const canton = gln?.canton;
  const provincia = gln?.provincia;
  const pais = gln?.pais;

  return (
    <div style={{ padding: 20 }}>
      <Descriptions
        title={
          <span style={{ color: '#fa541c' }}>
            <strong>{gln?.gln}</strong>
          </span>
        }
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
      >
        <Descriptions.Item label={labelWithFormat('Localización', 'Location')}>
          {gln?.cod_loc_a}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('RUC', 'Identification number')}
        >
          {cliente?.ruccli}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Empresa', 'Company')}>
          {cliente?.nomcli}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Representante legal', 'Legal representative')}
        >
          {cliente?.representante}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions
        title={
          <span style={{ color: '#fa541c' }}>Localización / Location</span>
        }
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
        style={{ marginTop: 20 }}
      >
        <Descriptions.Item
          label={labelWithFormat('Tipo Localización', 'Location type')}
        >
          {gln?.cod_tiploc}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Latitud', 'Latitude')}>
          {gln?.latitud}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Longitud', 'Longitude')}>
          {gln?.longitud}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('País', 'Country')}>
          {pais?.pais}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Provincia', 'State')}>
          {provincia?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Ciudad', 'City')}>
          {ciudad?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Dirección', 'Address')}
          span={2}
        >
          {cliente?.dircli}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Teléfono', 'Phone')}>
          {cliente?.telcli}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Email', 'Email')}>
          {cliente?.email}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Página web', 'Website')}>
          {cliente?.web}
        </Descriptions.Item>
      </Descriptions>

      <Descriptions
        title={
          <span style={{ color: '#fa541c' }}>Certificados / Certificates</span>
        }
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
        style={{ marginTop: 20 }}
      >
        <Descriptions.Item label="FDA">{gln?.fda}</Descriptions.Item>
        <Descriptions.Item label="Europa U">{gln?.europa}</Descriptions.Item>
        <Descriptions.Item label="GLOBAL GAP">{gln?.global}</Descriptions.Item>
        <Descriptions.Item label="Otro 1">{gln?.otro1}</Descriptions.Item>
        <Descriptions.Item label="Otro 2">{gln?.otro2}</Descriptions.Item>
      </Descriptions>

      <Descriptions
        title={<span style={{ color: '#fa541c' }}>Contacto / Contact</span>}
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
        style={{ marginTop: 20 }}
      >
        <Descriptions.Item label={labelWithFormat('Nombre', 'Name')}>
          {gln?.contacto}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Email', 'Email')}>
          {gln?.email}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Teléfono', 'Phone')}>
          {gln?.celular}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default GLNDetails;
